import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class MultiFarmService {
  private apiBaseUrl = environment.apiBaseUrl;
  listParent$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  listChild$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) {}

  getObjListParent() {
    return this.listParent$;
  }

  getObjListChild() {
    return this.listChild$;
  }

  getListParent(): Observable<any[]> {
    return this.http.get<any[]>(this.apiBaseUrl + 'api/private/v1/multiFarm/listParent').pipe(
      map((response) => {
        if (response) {
          this.listParent$.next(response);
          return response;
        }
        return [];
      })
    );
  }

  getListChild(): Observable<any[]> {
    return this.http.get<any[]>(this.apiBaseUrl + 'api/private/v1/multiFarm/listChild').pipe(
      map((response) => {
        if (response) {
          this.listChild$.next(response);
          return response;
        }
        return [];
      })
    );
  }

  saveLinkFarms(newFarm): Observable<any> {
    return this.http
      .post<any>(this.apiBaseUrl + 'api/private/v1/multiFarm/linkFarms/', newFarm)
      .pipe(
        map((response) => {
          if (response) {
            return response;
          }
        }),
        catchError((err) => {
          if (err.status === 404) {
            swal.fire(
              this.translate.instant('alert_errorHandling.label_HTTP404', {}),
              this.translate.instant('alert_errorHandling.subtitle', {}),
              'warning'
            );
          }
          return throwError(() => new Error('Request failed. Please try again.'));
        })
      );
  }

  revokeParentAuth(username) {
    const payloadParent = { parent: username };
    return this.http
      .post<any>(this.apiBaseUrl + 'api/private/v1/multiFarm/revokeParent/', payloadParent)
      .pipe(
        map((response) => {
          if (response && response.status === 200) {
            return swal.fire(
              this.translate.instant('alert_revoke_auth', {}),
              this.translate.instant('alert_errorHandling.subtitle', {}),
              'success'
            );
          }
        }),
        catchError((err) => {
          if (err.status === 404) {
            swal.fire(
              this.translate.instant('alert_errorHandling.label_HTTP404', {}),
              this.translate.instant('alert_errorHandling.subtitle', {}),
              'warning'
            );
          }
          return throwError(() => new Error('Request failed. Please try again.'));
        })
      );
  }

  revokeChildAuth(username) {
    const payloadChild = { child: username };
    return this.http
      .post<any>(this.apiBaseUrl + 'api/private/v1/multiFarm/revokeChild', payloadChild)
      .pipe(
        map((response) => {
          if (response && response.status === 200) {
            return swal.fire(
              this.translate.instant('alert_revoke_auth', {}),
              this.translate.instant('alert_errorHandling.subtitle', {}),
              'success'
            );
          }
        }),
        catchError((err) => {
          if (err.status === 404) {
            swal.fire(
              this.translate.instant('alert_errorHandling.label_HTTP404', {}),
              this.translate.instant('alert_errorHandling.subtitle', {}),
              'warning'
            );
          }
          return throwError(() => new Error('Request failed. Please try again.'));
        })
      );
  }

  postForNewMultiFarmToken(): Observable<any> {
    return this.http
      .post<any>(this.apiBaseUrl + 'api/private/v1/auth/userMultiFarmToken', null)
      .pipe(map((response) => response));
  }
}
